module.exports = __webpack_public_path__ + "static/media/Oracle-Logo.43de4899.png";